export default "__VITE_ASSET__54d7076d__"